import {DataTableParams} from '@symplicity/syng';

export const defaultPaginationState: DataTableParams = {
    'limit': 10,
    'page': 1,
    'sortBy': 'display',
    'sortAsc': true
};

export const dbMapping = {
    'active': {
        'display': 'name',
        'category_name': 'category',
        'modified': 'modified',
        'published_on': 'published_on',
        'participant_count': 'participant_count',
    },
    'archived': {
        'display': 'name',
        'category_name': 'category',
        'modified': 'modified',
        'published_on': 'published_on',
        'participant_count': 'participant_count'
    },
    'eligibleStudent': {
        'display': 'lname',
        'fname': 'fname',
        'resolveMajor': 'major',
        'email': 'email',
        'year': 'year',
        'graduation_date': 'graduation_date',
        'status': 'status'
    },
    'participant': {
        'lname': 'lname',
        'fname': 'fname',
        'resolveMajor': 'major',
        'year': 'year',
        'percent_task_complete': 'percent_task_complete',
        'started_on': 'started_on',
        'display': 'started_on',
        'completed_on': 'completed_on'
    }
};
